import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { brandColors } from '../../theme/mixins';

export const wrapperStyles: SxProps<Theme> = { mt: 2.5 };

export const labelStyles: SxProps<Theme> = { fontWeight: 600, mb: 0.5 };

export const hintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: '0.85rem',
    mb: 1,
};

/**
 * Wide and short, the shape of the rule it ends up on in the PDF. The ratio is fixed
 * rather than a height, because the exported image keeps whatever proportions the box had
 * and the document reserves 50mm x 17mm for it.
 */
export const padBoxStyles: SxProps<Theme> = {
    position: 'relative',
    aspectRatio: '3 / 1',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    overflow: 'hidden',
    // Not `transparent`: the ink is near-black and the pad may sit on any clinic's surface.
    backgroundColor: 'background.paper',
};

export const padBoxErrorStyles: SxProps<Theme> = {
    ...(padBoxStyles as object),
    borderColor: 'error.main',
};

export const canvasStyles: SxProps<Theme> = {
    display: 'block',
    width: '100%',
    height: '100%',
    // Without this a finger scrolls the page instead of drawing, and the pad appears dead
    // on the one kind of device it exists for.
    touchAction: 'none',
    cursor: 'crosshair',
};

/**
 * The line to sign on, and the words saying so. Sits under the canvas and stops taking
 * pointer events, so it can never swallow the first stroke.
 */
export const baselineStyles: SxProps<Theme> = {
    position: 'absolute',
    left: '8%',
    right: '8%',
    bottom: '26%',
    borderBottom: '1px dashed',
    borderColor: 'divider',
    pointerEvents: 'none',
};

export const placeholderStyles: SxProps<Theme> = {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: '8%',
    textAlign: 'center',
    color: 'text.disabled',
    fontSize: '0.8rem',
    pointerEvents: 'none',
};

export const actionsStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: 0.5,
};

export const helperTextStyles: SxProps<Theme> = { mt: 0.5, ml: 1.75 };

export const signedMarkStyles: SxProps<Theme> = {
    color: brandColors.primary,
    fontSize: '0.8rem',
};
